import { AES } from 'crypto-js'
import key from './key'

/**
 * テキストを暗号化する
 * @param {string} text
 * @returns {string} 暗号化済みテキスト
 */
export const encrypt = text => AES.encrypt(text, key).toString()
